import React, { useState } from "react";
import "./LeadForm.css";
import { submitLead, getCampaignSource } from "./leadApi";

const BUSINESS_TYPES = [
  "Restaurant / Food",
  "Retail / Shop",
  "Salon / Beauty",
  "Clinic / Healthcare",
  "Professional Services",
  "Other",
];

const LeadForm = ({ compact = false, packageName = "", source = "", onSuccess }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", businessType: "", message: "" });
  const [status, setStatus] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", text: "" });
    try {
      const data = await submitLead({
        ...form,
        packageName,
        source: source || getCampaignSource(),
        message: form.message || "Interested in AI4Bazaar website services",
      });
      setStatus({ type: "success", text: data.message || "Thank you! We will call you within 24 hours." });
      setForm({ name: "", phone: "", email: "", businessType: "", message: "" });
      if (onSuccess) onSuccess();
    } catch (err) {
      setStatus({ type: "error", text: err.message || "Something went wrong. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className={`lead-form ${compact ? "lead-form-compact" : ""}`} onSubmit={handleSubmit}>
      <h3 className="lead-form-title">{compact ? "Get Your Free Quote" : "Start Your Website Today"}</h3>
      <p className="lead-form-sub">Fill in your details — our team will reach out within 24 hours.</p>
      {status.text && <p className={`lead-form-status lead-form-status-${status.type}`}>{status.text}</p>}
      <input type="text" name="name" placeholder="Your Name *" value={form.name} onChange={handleChange} required disabled={loading} />
      <input type="tel" name="phone" placeholder="Phone Number *" value={form.phone} onChange={handleChange} required disabled={loading} pattern="[0-9+\-\s]{10,15}" />
      <input type="email" name="email" placeholder="Email Address *" value={form.email} onChange={handleChange} required disabled={loading} />
      <select name="businessType" value={form.businessType} onChange={handleChange} required disabled={loading}>
        <option value="">Select Business Type *</option>
        {BUSINESS_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
      </select>
      {!compact && (
        <textarea name="message" placeholder="Tell us about your business (optional)" rows="3" value={form.message} onChange={handleChange} disabled={loading} />
      )}
      <button type="submit" disabled={loading}>{loading ? "Submitting..." : "Get Free Quote →"}</button>
      <p className="lead-form-trust">✓ No spam · ✓ Free consultation · ✓ 500+ businesses served</p>
    </form>
  );
};

export default LeadForm;
